import RolloutStatusCounts from './RolloutStatusCounts';
import RolloutStudioSummaryDTO from './RolloutStudioSummaryDTO';

export default class RolloutGlobalSummaryDTO {

    public counts: RolloutStatusCounts;
    public perStudio: RolloutStudioSummaryDTO[] = [];

    constructor(data: { [key: string]: any }) {
        this.counts = new RolloutStatusCounts(data['counts'] ?? {});
        this.perStudio = Array.isArray(data['perStudio']) ? data['perStudio']
            .map((studio: any) => new RolloutStudioSummaryDTO(studio)) : [];
    }
}
